import * as Sentry from '@sentry/vue';
import moment from 'moment-timezone';
function isDST(d) {
    let jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
    let jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
    return Math.max(jan, jul) !== d.getTimezoneOffset();
}

const fetchRefreshedToken = oldToken => {
  return new Promise((resolve, reject) => {
    $http
      .post('/api/auth/refresh-token', {
        token: oldToken
      })
      .then(resp => {
        resolve(resp.data);
      })
      .catch(error => {
        console.error('fetchRefreshedToken', error);
        //alert('Your session has expired. Please log in again. Redirecting you to login now...');
        //window.location.replace('/login?_r='+ (Math.random().toString(36).substr(2, 5) +'&redirToUrl='+(location.pathname+location.search).substr(1)));
        reject(error);
      });
  });
};
export default {
  namespaced: true,

  state: () => ({
    dstActive: moment().tz('America/Los_Angeles').isDST(),
    dstLocalActive: moment().isDST(),  //isDST(new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDay())),
    env: 'prod',
    has_logged_in: false,
    last_login_check: new Date(),
    token: '',
    refreshToken: '',
    refreshTokenTracker: null,
    user: {
      fullName: 'Guest',
      firstName: 'Guest',
      lastName: '',
      email: '',
      id: ''
    },
    roles: []
  }),

  mutations: {
    updateLoggedInState(state, payload) {
      state.lastLoginCheck = new Date();
    },
    setRefreshToken(state, payload) {
      state.token = payload.jwtToken;
      window.$cookie.set('auth_token', payload.jwtToken);
      state.refreshToken = payload.refreshToken;
      localStorage.setItem('refreshToken', payload.refreshToken);
    },
    setToken(state, payload) {
      state.token = payload.auth_token;
      $http.defaults.headers.common['Authorization'] = `Bearer ${state.token}`;
    },
    setUser(state, usr) {
      state.user = usr;
    },
    setUserRoles(state, roles) {
      state.roles = roles;
    },
    setEnv(state, env) {
      state.env = env;
    },
    setUserData(state, payload) {
      state.has_logged_in = true;
      if (payload.refreshToken) {
        state.refreshToken = payload.refreshToken;
        localStorage.setItem('refreshToken', payload.refreshToken);
      }
      state.token = payload.auth_token;
      state.user = payload.user;
      state.env = payload.env;
      state.roles = payload.user.userRoles;
      $http.defaults.headers.common['Authorization'] = `Bearer ${state.token}`;
    }
  },

  actions: {
    fetchRefreshedToken : fetchRefreshedToken,
    logout: ({ state, commit, rootState }) => {
      state.refreshToken = '';
      localStorage.removeItem('refreshToken');
      window.$cookie.set('auth_token', '');
      window.$cookie.remove('auth_token');
      state.has_logged_in = false;
      state.token = '';
      state.roles = [];
      state.refreshTokenTracker = null;
      state.refreshToken = '';
      state.user = {};
    },

    refreshToken({ state, commit, rootState }, oldToken) {
      return new Promise((resolve, reject) => {
        fetchRefreshedToken(oldToken)
          .then(response => {

            if (response.env == 'prod') {
              Sentry.setUser({ email: response.email, id: response.id });
            } else {
              Sentry.setUser({ email: response.email, id: response.id });
            }
            resolve(response);
            commit('setUserData', {
              auth_token: response.jwtToken,
              user: response,
              refreshToken: response.refreshToken,
              env: response.env
            });
          })
          .catch(err => {
            // should raise error and redirect to login
            reject(err);
          });
      });
    },

    autoRefreshToken({ state, commit, rootState }) {
      return new Promise((resolve, reject) => {
        if (state.refreshTokenTracker != null) {
          clearInterval(state.refreshTokenTracker);
        }
        state.refreshTokenTracker = setInterval(() => {
          let storageRefToken = localStorage.getItem('refreshToken');
          if (storageRefToken != state.refreshToken) {
            state.refreshToken = storageRefToken;
          }
          fetchRefreshedToken(state.refreshToken)
            .then(response => {
              document.dispatchEvent(
                new CustomEvent('swSiteUp', { isUp: true })
              );
              if (window.location.href.includes('silueta.app')) {
                alert('Connect has moved to a new domain! Redirecting you now to the new site! Do not forget your password!');
                if (response.env == 'prod') {
                  if(response.userRoles.includes('brand-user')) {
                    window.location.replace('https://UxAppSupport.com/?redirToUrl='+(location.pathname+location.search).substr(1));
                  } else {
                    window.location.replace('https://support.ux.app/?redirToUrl='+(location.pathname+location.search).substr(1));
                  }
                } else {
                  if(response.userRoles.includes('brand-user')) {
                    window.location.replace('https://staging.UxAppSupport.com/?redirToUrl='+(location.pathname+location.search).substr(1));
                  } else {
                    window.location.replace('https://stagingsupport.ux.app/?redirToUrl='+(location.pathname+location.search).substr(1));
                  }
                }
              }
              commit('setRefreshToken', response);
              resolve(response.refreshToken);
            })
            .catch(err => {
              //alert('Your session has expired. Please log in again. Redirecting you to login now...');
              //window.location.replace('/login?_r='+ (Math.random().toString(36).substr(2, 5) +'&redirToUrl='+(location.pathname+location.search).substr(1)));
              // should raise error and redirect to login
              reject(err);
            });
        }, 5 * 60 * 1000);
      });
    }
  },

  getters: {
    isDST: state => {
      return state.dstActive;
    },
    isLocalDST: state => {
      return state.dstLocalActive;
    },
    getEnv: state => {
      return state.env;
    },
    getLastLoggedIn: state => {
      return state.user;
    },
    getUserTimezone: (state) => {
      let timezone = -6;
      if(state.dstLocalActive) {
        timezone = -5;
      }
      if (state &&state.user) {
        timezone = state.user.timezone;
        if(state.dstLocalActive) {
          timezone++;
        }
      }
      return timezone;
    },
    getUserTimezonePCDiff:(state) => {
      let defaultTz = -8;
      let timezone = -6;
      if(state.dstLocalActive) {
        timezone = -5;
      }
      if (state.dstActive) {
        defaultTz = -7;
      }
      if (state &&state.user) {
        timezone = state.user.timezone;
        if(state.dstLocalActive) {
          timezone++;
        }
      }
      let diffTz = (defaultTz - timezone);
      return -diffTz;
    },
    getUserData: state => {
      return state.user;
    },
    getUserRoles: state => {
      return state.roles;
    },
    getToken: state => {
      return state.token;
    },
    getRefreshToken: state => {
      let storageRefToken = localStorage.getItem('refreshToken');
      if (storageRefToken != state.refreshToken) {
        state.refreshToken = storageRefToken;
      }
      return state.refreshToken;
    },
    isLoggedIn: state => {
      return state.has_logged_in;
    },
    hasUserRole: state => role => {
      return state.roles.includes(role);
    }
  }
};
